import SectionHeading from "./SectionHeading";
import { pricingItems } from "@/mocks/home";

const notes = [
  { icon: "ri-file-search-line", text: "방문 정밀 진단 무료" },
  { icon: "ri-archive-stack-line", text: "부품 비용 포함가 안내" },
  { icon: "ri-shield-star-line", text: "수리 부위별 무상 보증" },
  { icon: "ri-wallet-3-line", text: "카드·현금영수증 발급" },
];

export default function RepairPricing() {
  return (
    <section id="price" className="w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Repair Price"
          title="미리 확인하는"
          highlight="수리비용"
          desc="모델과 증상에 따라 정확한 비용은 달라질 수 있습니다. 아래는 대표적인 수리 항목의 시작 가격입니다."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {pricingItems.map((item, index) => (
            <article
              key={item.id}
              className={`reveal relative flex flex-col rounded-lg border p-6 transition-colors ${
                item.highlight
                  ? "border-primary-500 bg-primary-500"
                  : "border-background-200 bg-background-50 hover:border-primary-300"
              }`}
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              {item.highlight && (
                <span className="absolute -top-3 left-6 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-black text-primary-950">
                  가장 많이 찾는 수리
                </span>
              )}
              <h3
                className={`font-heading text-lg font-black ${
                  item.highlight ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {item.name}
              </h3>
              <p
                className={`mt-1.5 font-body text-sm ${
                  item.highlight ? "text-background-200" : "text-foreground-600"
                }`}
              >
                {item.desc}
              </p>

              <div className="mt-5 flex items-end gap-1.5">
                <span
                  className={`font-heading text-[32px] font-black leading-none ${
                    item.highlight ? "text-background-50" : "text-primary-600"
                  }`}
                >
                  {item.price}
                </span>
                <span
                  className={`font-label text-sm font-bold ${
                    item.highlight ? "text-background-200" : "text-foreground-600"
                  }`}
                >
                  원 {item.unit}
                </span>
              </div>

              <ul
                className={`mt-5 flex flex-1 flex-col gap-2.5 border-t pt-5 ${
                  item.highlight ? "border-background-50/20" : "border-background-200"
                }`}
              >
                {item.features.map((f) => (
                  <li
                    key={f}
                    className={`flex items-start gap-2 font-label text-sm font-medium ${
                      item.highlight ? "text-background-100" : "text-foreground-700"
                    }`}
                  >
                    <i
                      className={`mt-0.5 ${
                        item.highlight ? "ri-checkbox-circle-fill text-accent-300" : "ri-check-line text-accent-600"
                      }`}
                    ></i>
                    {f}
                  </li>
                ))}
              </ul>

              <a
                href="#inquiry"
                className={`mt-6 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-4 py-3 font-label text-sm font-bold transition-colors ${
                  item.highlight
                    ? "bg-background-50 text-primary-700 hover:bg-background-200"
                    : "bg-primary-100 text-primary-700 hover:bg-primary-200"
                }`}
              >
                견적 문의
                <i className="ri-arrow-right-line"></i>
              </a>
            </article>
          ))}
        </div>

        <div className="reveal mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 rounded-lg border border-background-200 bg-background-100 px-6 py-6">
          {notes.map((note) => (
            <div key={note.text} className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-primary-600">
                <i className={`${note.icon} text-lg`}></i>
              </span>
              <span className="font-label text-sm font-bold text-foreground-700">{note.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}